import { Link } from "react-router-dom";
import images from "./teamImages.js";
import chambres from "./teamImagesChambre.js";
import AnimatedScroll from "../../components/AnimatedScroll/AnimatedScroll.jsx";
import { getImage, getImagesConfig } from "../../config/imageConfig";
import Reservation from "../Reservation/Reservation.jsx";

import { useRef } from "react";
import useInViewClass from "../../hooks/useInViewClass";

function Team({ section = "all" }) {
  const showRestaurant = section !== "chambres";
  const showChambres = section !== "restaurant";

  if (showRestaurant && !showChambres) {
    document.title = "Carpe Diem - Notre Restaurant";
  } else if (!showRestaurant && showChambres) {
    document.title = "Carpe Diem - Nos Chambres";
  } else {
    document.title = "Carpe Diem - Restaurant & Chambres";
  }

  const galleryRef = useRef(null);
  const chambreRef = useRef(null);

  // Récupérer la configuration et fusionner avec les images statiques
  const config = getImagesConfig();

  const getCustomText = (customValue, fallbackValue) => {
    if (typeof customValue === "string" && customValue.trim().length > 0) {
      return customValue;
    }
    return fallbackValue;
  };

  // Pour les galeries, fusionner chaque champ (src/alt/caption) avec la config admin
  const restaurantImages = images.map((img, index) => {
    const customImg = config.galerieRestaurant?.[index] || {};
    return {
      ...img,
      src: customImg.src && customImg.src.length > 0 ? customImg.src : img.src,
      alt: getCustomText(customImg.alt, img.alt || img.title),
      caption: getCustomText(customImg.caption, img.caption || img.title),
    };
  });

  const chambreImages = chambres.map((img, index) => {
    const customImg = config.galerieChambres?.[index] || {};
    return {
      ...img,
      src: customImg.src && customImg.src.length > 0 ? customImg.src : img.src,
      alt: getCustomText(customImg.alt, img.alt || img.title),
      caption: getCustomText(customImg.caption, img.caption || img.title),
    };
  });

  // observe les <figure> à l'intérieur de la gallery et ajoute 'is-visible' quand visible
  useInViewClass(galleryRef, "figure", "is-visible", {
    rootMargin: "0px 0px -80px 0px",
    threshold: 0.12,
  });
  useInViewClass(chambreRef, "figure", "is-visible", {
    rootMargin: "0px 0px -80px 0px",
    threshold: 0.12,
  });

  return (
    <>
      {showRestaurant && (
      <section>
        <div className="Wrapper-sc">
          <div id="comp-176197eace3" className="comp"></div>
          <div id="comp-1" className="comp"></div>
          <div className="Team-StyledContainer-sc TeamStyled">
            <div className="Team-WmCustomContainer-sc TeamCContainer">
              <div className="TextContent-sc">
                <AnimatedScroll>
                  <h1 className="Team-Title-sc Special-Title">
                    Notre Restaurant
                  </h1>
                </AnimatedScroll>
                <AnimatedScroll>
                  <p className="Team-Paragraph-sc textLi">
                    Bienvenue chez Carpe Diem, un lieu où la passion de la
                    cuisine rencontre la convivialité. Notre équipe vous
                    accueille dans un cadre chaleureux et raffiné, idéal pour
                    partager des moments uniques autour de plats savoureux.
                  </p>
                </AnimatedScroll>
                <AnimatedScroll>
                  <p className="Team-Paragraph-sc textLi paragraph2">
                    Ici, chaque recette est préparée avec amour et savoir-faire,
                    pour vous offrir une expérience culinaire authentique. Venez
                    découvrir notre carte et laissez-vous séduire par l’ambiance
                    familiale de notre restaurant.
                  </p>
                </AnimatedScroll>
              </div>
              <div className="TextImageContent-sc">
                <AnimatedScroll>
                  <p className="Slogan-sc TitleStats">
                    Le restaurant <br /> qu'il vous faut !
                  </p>
                </AnimatedScroll>
                <AnimatedScroll>
                  <div className="buttonReserve">
                    <div className="singleButtonReserve">
                      <div className="linkWrapperReserve ">
                        <Link
                          className="buttonLinkReserve"
                          to="/notre-restaurant#reservation-restaurant"
                        >
                          Réserver une table
                        </Link>
                      </div>
                    </div>
                  </div>
                </AnimatedScroll>
                <AnimatedScroll>
                  <p className="Name-sc ParagraphStats">Carpe Diem</p>
                </AnimatedScroll>
                <div className="ImageWrapper-sc">
                  <div className="Team-ControlContainer-sc">
                    <div className="LazyLoad is-visible">
                      <AnimatedScroll>
                        <figure className="lazy-figure styled__Figure-sc">
                          <img
                            className="feature-image img-loaded Img-sc"
                            alt="Feature illustration"
                            sizes="[object Object]"
                            src={
                              getImage("team.restaurantMain") ||
                              "https://i.ibb.co/Wvsywqjc/resto-jour-devanture.jpg"
                            }
                            style={{
                              width: "290px",
                              left: "0px",
                              top: "-66px",
                              transform: "rotate(0deg)",
                              height: "auto",
                              position: "absolute",
                            }}
                          />
                        </figure>
                      </AnimatedScroll>
                    </div>
                    <div className="image-state-overlay StateOverlay-sc">
                      <div className="Content-sc"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      )}

      {showRestaurant && (
      <section className="gallery-section">
        <div className="gallery" ref={galleryRef}>
          {restaurantImages.map((img, idx) => (
            <figure key={idx} className="animate-hidden">
              <img src={img.src} alt={img.alt || img.title} />
              <figcaption>{img.caption || img.title}</figcaption>
            </figure>
          ))}
        </div>
      </section>
      )}
      {showRestaurant && (
      <section id="reservation-restaurant" className="gallery-section">
        <div className="WMContainer-sc">
          <Reservation
            forcedType="table"
            heading="Reserver une table"
            manageDocumentTitle={false}
            blocked={true}
            unavailableMessage="Les réservations en ligne sont temporairement suspendues. Pour réserver une table, contactez-nous directement au +33 5 63 71 44 45 ou par e-mail."
          />
        </div>
      </section>
      )}
      {showChambres && (
      <section>
        <div className="Wrapper-sc">
          <div id="comp-176197eace3" className="comp"></div>
          <div id="comp-1" className="comp"></div>
          <div className="Team-StyledContainer-sc TeamStyled hotelSection">
            <div className="Team-WmCustomContainer-sc TeamCContainer">
              <div className="TextContent-sc">
                <AnimatedScroll>
                  <h1 className="Team-Title-sc Special-Title hotelH1">
                    Nos Chambres
                  </h1>
                </AnimatedScroll>
                <AnimatedScroll>
                  <p className="Team-Paragraph-sc textLi hotelP">
                    Découvrez nos chambres cosy et confortables, pensées pour
                    votre bien-être et votre repos. Chaque espace est décoré
                    avec soin pour vous offrir une atmosphère chaleureuse et
                    apaisante.
                  </p>
                </AnimatedScroll>
                <AnimatedScroll>
                  <p className="Team-Paragraph-sc textLi paragraph2 hotelP">
                    Profitez d’un séjour agréable au cœur de notre
                    établissement, avec tous les services nécessaires pour un
                    moment de détente. Réservez votre chambre et vivez une
                    expérience unique chez Carpe Diem.
                  </p>
                </AnimatedScroll>
              </div>
              <div className="TextImageContent-sc">
                <AnimatedScroll>
                  <p className="Slogan-sc TitleStats hotelP">
                    Besoin de repos ?
                  </p>
                </AnimatedScroll>
                <AnimatedScroll>
                  <div className="buttonReserve">
                    <div className="singleButtonReserve">
                      <div className="linkWrapperReserve ">
                        <Link
                          className="buttonLinkReserve"
                          to="/nos-chambres#reservation-chambre"
                        >
                          Réserver une chambre
                        </Link>
                      </div>
                    </div>
                  </div>
                </AnimatedScroll>
                <AnimatedScroll>
                  <p className="Name-sc ParagraphStats hotelH1">Carpe Diem</p>
                </AnimatedScroll>
                <div className="ImageWrapper-sc">
                  <div className="Team-ControlContainer-sc">
                    <div className="LazyLoad is-visible">
                      <AnimatedScroll>
                        <figure className="lazy-figure styled__Figure-sc">
                          <img
                            className="feature-image img-loaded Img-sc"
                            alt="Feature illustration"
                            sizes="[object Object]"
                            src={
                              getImage("team.chambreMain") ||
                              "https://i.ibb.co/HfGJLP06/resto-nuit.jpg"
                            }
                            style={{
                              width: "290px",
                              left: "0px",
                              top: "-66px",
                              transform: "rotate(0deg)",
                              height: "auto",
                              position: "absolute",
                            }}
                          />
                        </figure>
                      </AnimatedScroll>
                    </div>
                    <div className="image-state-overlay StateOverlay-sc">
                      <div className="Content-sc"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      )}
      {showChambres && (
      <section className="gallery-section hotel-gallery">
        <div className="gallery" ref={chambreRef}>
          {chambreImages.map((img, idx) => (
            <figure key={idx} className="animate-hidden">
              <img src={img.src} alt={img.alt || img.title} />
              <figcaption>{img.caption || img.title}</figcaption>
            </figure>
          ))}
        </div>
      </section>
      )}
      {showChambres && (
      <section
        id="reservation-chambre"
        className="gallery-section hotel-gallery"
      >
        <div className="WMContainer-sc">
          <div className="reservation-page reservation-align-top">
            <AnimatedScroll>
              <h1>Réserver une chambre</h1>
              <p className="reservation-urgent">
                Réservez directement sur Booking.com pour consulter les disponibilités et confirmer votre séjour.
              </p>
            </AnimatedScroll>
            <div style={{ textAlign: "center", margin: "2rem 0" }}>
              <a
                href="https://www.booking.com/hotel/fr/carpe-diem-goutrens.fr.html"
                target="_blank"
                rel="noopener noreferrer"
                className="contact-btn"
                style={{ display: "inline-block", textDecoration: "none" }}
              >
                Réserver sur Booking.com
              </a>
            </div>
          </div>
        </div>
      </section>
      )}
    </>
  );
}

export default Team;
